import { createSlice } from "@reduxjs/toolkit";
import { PV_CHECKLIST_STATIC } from "../../incpection.com/data/pvc_data";

const generateInitialChecklistState = () => {
  const checklist = {};

  PV_CHECKLIST_STATIC.forEach((section) => {
    section.subsections.forEach((sub) => {
      sub.items.forEach((item) => {
        checklist[item.key] = "na"; // default state
      });
    });
  });

  return checklist;
};

const initialState = generateInitialChecklistState();

const pvc_checkListSlice = createSlice({
  name: "pvc_list",
  initialState,
  reducers: {
    toggleItem: (state, action) => {
      const key = action.payload;

      if (state[key] === undefined) return;

      // cycle: na → true → false → na
      state[key] =
        state[key] === "na" ? true : state[key] === true ? false : "na";
    },

    setChecklistInitial: (state, action) => {
      Object.assign(state, action.payload);
    },

    resetSystemChecklist: (state) => {
      Object.keys(state).forEach((k) => {
        state[k] = "na";
      });
    },
  },
});

export const { toggleItem, resetSystemChecklist, setChecklistInitial } =
  pvc_checkListSlice.actions;

export default pvc_checkListSlice.reducer;
